import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import Modal from "react-bootstrap/Modal";
import nest from "../../../services/nest";
import Loading from "../../../components/Loading";
import { getUserId } from "../../../services/auth";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function ModalEditarSenha({
  mostrar,
  handleClose,
  setAlerta,
}) {
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [repeatPasswordVisible, setRepeatPasswordVisible] = useState(false);

  const [form, setForm] = useState({
    newPassword:  "",
    repeatPassword: "",
    password: "",
  });
  useEffect(() => { 
    if (mostrar) {
      setForm({
        newPassword: "",
        repeatPassword: "",
        password: "",
      });
    }
  }, [mostrar]);

  const atualizazrUsuarioMaster = async () => {
    if (!form.newPassword || !form.repeatPassword || !form.password) {
      setAlerta({
        status: true,
        msg: "Preencha as senhas!",
        type: "error",
      });
      return false;
    }
    if (form.newPassword !== form.repeatPassword) {
      setAlerta({
        status: true,
        msg: "Nova senha repetida incorreta!",
        type: "error",
      });
      return false;
    }
    if (form.newPassword === form.password) {
                     
      setAlerta({
        status: true,
        msg: "Nova senha não pode ser igual a antiga!",
        type: "error",
      });
      return false;
    }

    let clienteUsuarioId = await getUserId();
    setLoading(true);
    const dados = {
      senhaAntiga: form.password,
      novaSenha: form.newPassword
    }
      nest.put('/cliente/cliente-usuarios/atualizarSenhaNova',
      dados,
      {
        params: {
          cliente_usuario_id: clienteUsuarioId,
        }
      })
      .then(function (response) {
        setLoading(false);
        handleClose();
        setAlerta({
          status: true,
          msg: "Senha atualizada com sucesso!",
          type: 'success'
        })
      })
      .catch(function (error) {
        setAlerta({
          status: true,
          msg: error.response?.data?.message || "Erro ao atualizar!",
          type: 'error'
        })
        console.log(error);
        setLoading(false);
      });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPassword = () => setPasswordVisible((show) => !show);
  const handleClickShowNewPassword = () => setNewPasswordVisible((show) => !show);
  const handleClickShowRepeatPassword = () => setRepeatPasswordVisible((show) => !show);
  return (
    <Modal show={mostrar} onHide={handleClose} centered>
      <Loading open={loading} />
      <Modal.Header closeButton style={{ paddingTop: 10, paddingBottom: 10 }}>
        <Modal.Title
          style={{
            color: "var(--main-bg-color)",
            width: "100%",
            textAlign: "center",
          }}
        >
          Alterar Senha
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginLeft: 50, marginRight: 50, marginTop: 0 }}>
          <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
            <InputLabel>Nova senha</InputLabel>
            <OutlinedInput
              type={ newPasswordVisible ? "text" : "password"}
              value={form.newPassword}
              onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowNewPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {newPasswordVisible ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Senha"
            />
          </FormControl>
          <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
            <InputLabel>Confirme a nova senha</InputLabel>
            <OutlinedInput
              type={repeatPasswordVisible ? "text" : "password"}
              value={form.repeatPassword}
              onChange={(e) => setForm({ ...form, repeatPassword: e.target.value })}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowRepeatPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {repeatPasswordVisible ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Senha"
            />
          </FormControl>
          <FormControl sx={{ m: 1, width: "100%" }} variant="outlined">
            <InputLabel>Senha antiga</InputLabel>
            <OutlinedInput
              type={passwordVisible ? "text" : "password"}
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {passwordVisible ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Senha"
            />
          </FormControl>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div onClick={() => handleClose()}>
          <Button style={{ backgroundColor: "#a3a3a3" }} variant="contained">
            Cancelar
          </Button>
        </div>
        <div onClick={() => atualizazrUsuarioMaster()}>
          <Button
            style={{ backgroundColor: "var(--main-bg-color)" }}
            variant="contained"
            disabled={loading}
          >
            Atualizar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalEditarSenha;
